import React, { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Form,
  FormControl,
  InputGroup,
  Row,
  Col,
  Button,
} from "react-bootstrap";
import "./style.scss";
import TopNavigation from "../../components/TopNavigation";

import * as PageRoutes from "../../utils/route_pages";
import * as Assets from "../../utils/svg_assets";
import { InformationDialog } from "../../components/DialogCollection";
import passwordValidator from "password-validator";
import {
  RenderInputError,
  RenderInputErrorOther,
} from "../../components/RenderInputError";
import { Base } from "../../components/RootLayout";

let schema = new passwordValidator();
schema
  .is()
  .min(8, "Password should be at least 8 characters long") // Minimum length 8
  .has()
  .uppercase() // Must have uppercase letters
  .has()
  .lowercase()
  // .has().symbols()
  .has()
  .not()
  .spaces(); // Should not have spaces;

const initPayload = {
  p_cur: "",
  p_new: "",
  p_con: "",
};

const ChangePage = (props) => {
  const [payload, setPayload] = useState(initPayload);
  const navigate = useNavigate();
  const [errState, setErrState] = useState([
    /**
     * Current Password
     */
    {
      index: 0,
      isError: false,
      message: [],
    },
    /**
     * New Password
     */
    {
      index: 1,
      isError: false,
      message: [],
    },
    /**
     * Confirm New Password
     */
    {
      index: 2,
      isError: false,
      message: [],
    },
    /**
     * general
     */
    {
      index: 3,
      isError: false,
      message: [],
    },
  ]);
  const [isCompleted, setIsCompisCompleted] = useState(false);
  const [errorMatch, setErrorMatch] = useState("");

  const [info, setInfo] = useState({
    show: false,
    icons: Assets.iconCheck,
    message: "",
    title: "",
    isError: false,
  });
  const [passwordType, setPasswordType] = useState({
    current: "password",
    new: "password",
    confirm: "password",
  });

  const validatePassword = () => {
    let rules = [
      {
        Pattern: "[A-Z]",
        Target: "upperCase",
      },
      {
        Pattern: "[a-z]",
        Target: "lowerCase",
      },
      {
        Pattern: "[0-9@#+-]",
        Target: "symbols",
      },
    ];

    let newPassword = document.getElementById("new_password").value;
    let confirmPassword = document.getElementById("confirm_password").value;
    let minLength = document.getElementById("minLength");

    minLength.classList.remove(
      newPassword.length > 7 ? "text-danger" : "text-green"
    );
    minLength.classList.add(
      newPassword.length > 7 ? "text-green" : "text-danger"
    );

    for (let i = 0; i < rules.length; i++) {
      let element = document.getElementById(rules[i].Target);
      element.classList.remove(
        new RegExp(rules[i].Pattern).test(newPassword)
          ? "text-danger"
          : "text-green"
      );
      element.classList.add(
        new RegExp(rules[i].Pattern).test(newPassword)
          ? "text-green"
          : "text-danger"
      );
    }
    checkIsCompleted();
    if (confirmPassword) checkConfirmPassword();
  };

  const checkConfirmPassword = () => {
    let newPassword = document.getElementById("new_password").value;
    let confirmPassword = document.getElementById("confirm_password").value;
    if (newPassword !== confirmPassword) {
      setErrorMatch("Password does not matching!");
    }
    checkIsCompleted();
  };

  const checkIsCompleted = (status = true) => {
    let completed = document.getElementsByClassName("text-green").length;
    let newPassword = document.getElementById("new_password").value;
    let confirmPassword = document.getElementById("confirm_password").value;

    if (completed === 4 && status && newPassword === confirmPassword) {
      setIsCompisCompleted(true);
    } else {
      setIsCompisCompleted(false);
    }
  };

  const resetLogin = async () => {
    const { p_cur, p_new, p_con } = payload;
    let states = errState;

    if (p_cur && p_new && p_con) {
      let index = 0;
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(payload)) {
        states[index].message = schema.validate(value, { list: true });
        states[index].isError = states[index].message.length > 0;
        index++;
      }
      states[3].message = [];
      states[3].isError = false;
      if (p_new === p_con) {
        await props
          .setPassword({
            old_password: p_cur,
            new_password: p_new,
          })
          .then(function (response) {
            if (response.status === 200) {
              setInfo({
                show: true,
                icons: Assets.iconCheck,
                message:
                  "Your password has been changed successfully. Use your new password to login.",
                title: "Password Updated",
                isError: false,
              });
            } else {
              setInfo({
                show: true,
                icons: Assets.iconCrossMark,
                message: response.message[0],
                title: "Failed to Update",
                isError: true,
              });
            }
          });
      } else {
        states[3].message = [
          "New password and confirm new password must be same",
        ];
        states[3].isError = true;
      }
    } else {
      states[3].message = ["Input fields are mandatory"];
      states[3].isError = true;
    }

    // console.log(states);
    setErrState([...states]);
  };

  const onHide = async () => {
    setInfo({
      ...info,
      show: false,
    });
    if (!info.isError) {
      await props.logout();
      navigate(PageRoutes.login);
    }
  };

  return (
    <Base>
      <TopNavigation
        titlePage="Change Password"
        toPath={PageRoutes.setting}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <Container className="mt-3">
        <Form>
          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>Current Password</Form.Label>
              <InputGroup className="mb-3 group-input">
                <FormControl
                  id="current_password"
                  type={passwordType.current}
                  placeholder="Enter Current Password"
                  value={payload.p_cur}
                  onChange={(e) => {
                    setPayload({ ...payload, p_cur: e.target.value });
                  }}
                />
                <img
                  src={
                    passwordType.current === "password"
                      ? Assets.iconEye
                      : Assets.iconEyeActive
                  }
                  className="icon-view"
                  alt="eye"
                  onClick={() => {
                    setPasswordType({
                      ...passwordType,
                      current:
                        passwordType.current === "password"
                          ? "text"
                          : "password",
                    });
                  }}
                />
              </InputGroup>
              <RenderInputError messages={errState[0].message} />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>New Password</Form.Label>
              <InputGroup className="mb-3 group-input">
                <FormControl
                  id="new_password"
                  type={passwordType.new}
                  placeholder="Enter New Password"
                  onKeyUp={validatePassword}
                  value={payload.p_new}
                  onChange={(e) => {
                    setPayload({ ...payload, p_new: e.target.value });
                  }}
                />
                <img
                  src={
                    passwordType.new === "password"
                      ? Assets.iconEye
                      : Assets.iconEyeActive
                  }
                  className="icon-view"
                  alt="eye"
                  onClick={() => {
                    setPasswordType({
                      ...passwordType,
                      new:
                        passwordType.new === "password" ? "text" : "password",
                    });
                  }}
                />
              </InputGroup>
              <ul className="pl-1">
                <li id="minLength" className="text-danger">
                  At least 8 characters.
                </li>
                <li id="upperCase" className="text-danger">
                  At least one uppercase letter.
                </li>
                <li id="lowerCase" className="text-danger">
                  At least one lowercase letter.
                </li>
                <li id="symbols" className="text-danger">
                  At least one number OR one special character +,-,#,@.
                </li>
              </ul>
              <RenderInputError messages={errState[1].message} />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>Confirm New Password</Form.Label>
              <InputGroup className="mb-3 group-input">
                <FormControl
                  id="confirm_password"
                  type={passwordType.confirm}
                  placeholder="Enter Confirm New Password"
                  onKeyUp={checkConfirmPassword}
                  value={payload.p_con}
                  onChange={(e) => {
                    setPayload({ ...payload, p_con: e.target.value });
                  }}
                />
                <img
                  src={
                    passwordType.confirm === "password"
                      ? Assets.iconEye
                      : Assets.iconEyeActive
                  }
                  className="icon-view"
                  alt="eye"
                  onClick={() => {
                    setPasswordType({
                      ...passwordType,
                      confirm:
                        passwordType.confirm === "password"
                          ? "text"
                          : "password",
                    });
                  }}
                />
              </InputGroup>
              {!isCompleted ? (
                <div className="text-danger">{errorMatch}</div>
              ) : (
                ""
              )}
              <RenderInputError messages={errState[2].message} />
              <RenderInputErrorOther messages={errState[3].message} />
            </Form.Group>
          </Row>
          <InformationDialog
            icon={info.icons}
            title={info.title}
            message={info.message}
            show={info.show}
            onHide={onHide}
          />
          <Row className="mb-3">
            <Col>
              <Button
                className="btn-change border-0"
                onClick={resetLogin}
                disabled={!isCompleted ? true : false}
              >
                Change Password
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </Base>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setPassword: dispatch.ProfileSM.setPassword,
  logout: dispatch.LoginSM.logout,
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePage);
